const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const registerUser = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'REGISTER_USER_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, 'data': action.data }
  case 'REGISTER_USER_FAILED':
    return { ...state, ...INITIAL_STATE, 'errors': action.data }
  default:
    return { ...state }
  }
};
  
export default registerUser;